import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=43c3fdf8&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=43c3fdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c3fdf8",
  null
  
)

export default component.exports